import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';
import { logoutSuccess } from '../auth/authSlice';

// Define a type for the slice state
interface CanvasState {
  uiPayload: Record<string, unknown> | null;
  isLoading: boolean;
}

const initialState: CanvasState = {
  uiPayload: null,
  isLoading: false,
};

export const canvasSlice = createSlice({
  name: 'canvas',
  initialState,
  reducers: {
    setUiPayload: (state, action: PayloadAction<Record<string, unknown> | null>) => {
      state.uiPayload = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    clearCanvas: (state) => {
      state.uiPayload = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutSuccess, (state) => {
      state.uiPayload = null;
      state.isLoading = false;
    });
  },
});

export const { setUiPayload, setLoading, clearCanvas } = canvasSlice.actions;

export const selectCanvasUiPayload = (state: RootState) => state.canvas.uiPayload;
export const selectIsCanvasLoading = (state: RootState) => state.canvas.isLoading;

export default canvasSlice.reducer;
